export const sortOptions = [
  {
    id: "timeGoDown",
    label: "Newest First",
    value: "createdAt desc",
  },
  {
    id: "ratingGoUp",
    label: "Highest Rating First",
    value: "avgRate desc",
  },
  {
    id: "priceGoUp",
    label: "Lowest Price First",
    value: "price asc",
  },
  {
    id: "priceGoDown",
    label: "Highest Price First",
    value: "price desc",
  },
];

export const pageSizeOptions = [
  {
    id: "12",
    label: "12 per page",
    value: 12,
  },
  {
    id: "24",
    label: "24 per page",
    value: 24,
  },
  {
    id: "48",
    label: "48 per page",
    value: 48,
  },
];

export const defaultFilters = {
  CategoryId: [],
  LevelIds: [],
  AudioLanguageIds: [],
  IsFree: false,
  IsDiscount: false,
  Rate: -1,
  MinPrice: 0,
  MaxPrice: 1000,
};
